import React from "react"
import {NavLink} from 'react-router-dom';

import ScrollPosition from "../hook/ScrollPosition";



const NavNoback = () => {
   const scrollPosition = ScrollPosition()

   // CSS
   const NobackNav = 
   {height: '90px', width: '100%', boxSizing: 'border-box' ,padding: '0 3% 0 2%',
   position: 'fixed', top: '0', left: '0', display: 'flex', justifyContent: 'space-between'};

   const h1 = 
   {width: '20%', height: '90px',}
   const a = 
   {height: '90px', width: '100%', display: 'flex', alignItems: 'center',}
   const logoImg = 
   {height: '70px',}

   const nav = 
   {width: '80%', display: 'flex', alignItems: 'center', justifyContent: 'space-around',}
   const p = 
   {display: 'flex',}
   const pli = 
   {marginRight:'10px',}
   // 활성화된 메뉴 컬러
   const activeStyle={
      color:'lavender',
  }
  

   return (
      <header id='NobackNav' style={NobackNav}
         className={scrollPosition >= 600 ? 'changeWhite' : ''}>
            {/* logo + nav */}
            <h1 style={h1}>
               <NavLink to='/' style={a}>
               <img src={require("../img/logo.png")} alt="logoImage" style={logoImg}
                  className={scrollPosition >= 800 ? 'invert' : ''} />
               </NavLink>
            </h1>
            <ul className="nav" style={nav}>
                <li><NavLink to="/" style={({isActive}) => (isActive ? activeStyle: undefined)}>ABOUT</NavLink></li>
                <li><NavLink to="/Shop" style={({isActive}) => (isActive ? activeStyle: undefined)}>SHOP & RESTAURANTS</NavLink></li>
                <li><NavLink to="/News" style={({isActive}) => (isActive ? activeStyle: undefined)}>NEWS</NavLink></li>
                <li><NavLink to="/Event" style={({isActive}) => (isActive ? activeStyle: undefined)}>EVENT</NavLink></li>
                <li><a href="https://shoplcdc.com/" target="_blank" rel="noopener noreferrer">LCDC MALL</a></li>
                <li><NavLink to="/Marketplace" style={({isActive}) => (isActive ? activeStyle: undefined)}>MARKET PLACE</NavLink></li>
                <p className="p" style={p}>
                   <li style={pli}><NavLink to="/Login" style={({isActive}) => (isActive ? activeStyle: undefined)}>LOGIN</NavLink></li>
                   <li><NavLink to="/Join" style={({isActive}) => (isActive ? activeStyle: undefined)}>JOIN</NavLink></li>
                </p>
            </ul>
      </header>
   )
}

export default NavNoback
